<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Employés",
          icon: "bi bi-people-fill",
          route: "employees-index",
        },
        {
          label: "Nouvel employé",
          icon: "bi bi-person-plus-fill",
          route: "employees-create",
        },
      ],
    };
  },
};
</script>
